export const STALE_TIME = 1000 * 60 * 5
